export const UPDATE_TOKEN_ACTION = 'UPDATE_TOKEN_ACTION' as const;
